import { CHARACTERS, SECONDS_TO_MINUTES } from './constants'

class TimerHelper {
  static formatTime(time: number): string {
    if (time <= 0) return '00:00'

    return `${Math.floor(time / SECONDS_TO_MINUTES)
      .toString()
      .padStart(CHARACTERS, '0')}:${(
      time -
      Math.floor(time / SECONDS_TO_MINUTES) * SECONDS_TO_MINUTES
    )
      .toString()
      .padStart(CHARACTERS, '0')}
    `
  }
}

export default TimerHelper
